import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center lg:justify-between items-center py-4 relative min-h-[60px]">
          <div className="flex-shrink-0 absolute lg:relative left-1/2 lg:left-0 transform -translate-x-1/2 lg:translate-x-0 flex items-center">
            <a href="#" className="block">
              <img
                src="https://static.readdy.ai/image/2806d7657d5f4d36c9110f806a03accf/910b3437c1bd90dd0b8d72d486f1f6c6.png"
                alt="Gavin Luke Tree and Stump Service Logo"
                className="h-20 lg:h-24 w-auto"
              />
            </a>
          </div>

          <nav className="hidden lg:flex space-x-8 items-center">
            <button
              onClick={() => scrollToSection('about')}
              className={`px-3 py-2 text-base font-medium transition-colors duration-200 cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-green-600' : 'text-white hover:text-green-400'
              }`}
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`px-3 py-2 text-base font-medium transition-colors duration-200 cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-green-600' : 'text-white hover:text-green-400'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`px-3 py-2 text-base font-medium transition-colors duration-200 cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-green-600' : 'text-white hover:text-green-400'
              }`}
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('quote')}
              className="bg-green-600 text-white hover:bg-green-700 px-6 py-2 rounded-md text-base font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Request a Quote
            </button>
          </nav>

          <div className="lg:hidden absolute right-0 flex items-center">
            <button
              type="button"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2 rounded-md ${
                isScrolled ? 'text-gray-800 hover:text-green-600' : 'text-white hover:text-green-400'
              }`}
            >
              <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <button
                onClick={() => scrollToSection('about')}
                className="text-gray-800 hover:text-green-600 block px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                About Us
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-gray-800 hover:text-green-600 block px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('testimonials')}
                className="text-gray-800 hover:text-green-600 block px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Testimonials
              </button>
              <button
                onClick={() => scrollToSection('quote')}
                className="bg-green-600 text-white hover:bg-green-700 block px-3 py-2 rounded-md text-base font-medium mt-4 w-full text-left cursor-pointer"
              >
                Request a Quote
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
